const mobileRegex =
  /mobile|iphone|ipod|ipad|android|blackberry|bb10|mini|windows\sce|palm/i;

export default function isMobileUA() {
  if (typeof navigator === "undefined") return false;
  return mobileRegex.test(navigator.userAgent);
}
